import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'zeudy-stacked-skin',
  styleUrl: 'zeudy-stacked-skin.scss',
  shadow: false,
})
export class zeudyStackedSkin {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
